module.exports = __webpack_public_path__ + "img/cases-part1-2.dd8c0303.png";